import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  CameraPTZWithArrow,
  CameraStationaryBase,
  CameraStationaryWithArrow,
} from 'features/mapping/icons';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const CamerasLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle titleSx={{ pb: 1 }}>
          {t('map.legends.cameras.title')}
        </LegendSectionTitle>
      }
    >
      <LegendListItem
        iconSrc={CameraPTZWithArrow.data}
        iconSize={18}
        primaryText={t('map.legends.cameras.legends.ptz.title')}
        secondary={t('map.legends.cameras.legends.ptz.subtitle')}
      />
      <LegendListItem
        iconSrc={CameraStationaryWithArrow.data}
        iconSize={16}
        primaryText={t('map.legends.cameras.legends.stationary.title')}
        secondary={t('map.legends.cameras.legends.stationary.subtitle')}
      />
      <LegendListItem
        iconSrc={CameraStationaryBase.data}
        iconSize={14}
        primaryText={t('map.legends.cameras.legends.stationaryNoHeading.title')}
        secondary={t(
          'map.legends.cameras.legends.stationaryNoHeading.subtitle',
        )}
      />
    </List>
  );
};
